import { Tooltip, Typography } from "antd";
import { CheckOutlined } from '@ant-design/icons';
import moment from "moment";
const { Text } = Typography;
export const CorrelationIdHandler = ({ data, handleCopy, copied }) => {
    const correlationId = data?.correlationId;
    const shortAddress = `${correlationId.substring(0, 8)}....${correlationId.substring(correlationId?.length - 8)}`
    return (
        <td style={{display:"contents"}}>
            {!correlationId && <div className='text-subTextColor'> -- </div>}
            <div className="">
            {correlationId && copied !== data?.id &&
                <Text key={data?.id} className="text-subTextColor !flex !justify-between !items-center px-2" copyable={{ text: correlationId, onCopy: handleCopy(data?.id) }} options={{ format: 'text/plain' }} >
                    <span>{shortAddress}</span>
                </Text>}
            {copied === data?.id &&
                <Text className="text-subTextColor !flex !justify-between !items-center px-2" key={data?.id}>
                    <span className="">{shortAddress}</span>
                    <Tooltip title="Copied" open={copied}>
                        <CheckOutlined className="ms-2 text-statusGreen" />
                    </Tooltip>
                </Text>}
                </div>
        </td>
    );
}

export const DateColumnHandler = ({data}) => {
    const date=(data?.dataItem?.creationTime);
    return (
        <td>
            <div className="gridLink text-light-valueColor">
                {date ? <> {moment.utc(date).local().format("DD/MM/YYYY hh:mm:ss A")}</> : date}
            </div>           
        </td>
    )
}